module.exports = __webpack_public_path__ + "img/suspension-bridges--full.297f3e38.jpg";